/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa logowania i przypominania hasła
 *
 * @export
 * @class Login
 * @extends {ModalForm}
 */
import { ModalForm } from "./ModalForm.class";

export class Login extends ModalForm {
	constructor() {
		super();
		this.modalLogin = null;
		this.myAccountBtn = null;
		this.loginBtn = null;
		this.loginMobileBtn = null;
		this.onFormReload = function () {
			this.initResetBtn();
		}.bind(this);
	}
	// ****************************************************************************************************
	// Inicjalizacja
	// ****************************************************************************************************
	initLoginForm() {
		var that = this;
		that.modalLogin = $('#modalLogin');
		that.initMyAccountBtn();
		that.initModalForm('#modalLogin');
	}
	// ****************************************************************************************************
	// Inicjalizacja przycisku 'moje konto'
	// ****************************************************************************************************
	initMyAccountBtn() {
		var that = this;
		that.myAccountBtn = $('#myAccountBtn');
		that.loginMobileBtn = $('#loginMobile');

		that.myAccountBtn.on('click', function (event) {
			if (!LOGGED) {
				that.modalLogin.modal('show');
			}
		}).on('inserted.bs.popover', function () {
			that.initLoginBtn($('#' + $(this).attr('aria-describedby')));
		});
		that.loginMobileBtn.on('click', function (event) {
			if (!LOGGED) {
				that.modalLogin.modal('show');
			}
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja przycisku 'zaloguj' w popover
	// ****************************************************************************************************
	initLoginBtn(popoverObj) {
		var that = this;
		that.loginBtn = popoverObj.find('.loginBtn');
		that.loginBtn.on('click', function () {
			that.myAccountBtn.trigger('click');
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja przycisku 'resetuj hasło' w modalu
	// ****************************************************************************************************
	initResetBtn() {
		var that = this;
		that.resetBtn = $('.logowanie #remindPassBtn');
		that.resetBtn.on('click', function () {
			//console.log('remindPassBtn');
			toolsObj.ajaxLoadData({
				updateBrowserHistory: false,
				url: '/password-reset',
				target: that.modalId + ' .modal-body',
				loadingMode: false,
				method: 'POST',
				forceAjaxPageLoad: true,
				sourceOfError: 'Login::initResetBtn',
				onComplete: function () {
					that.updateModalTitle();
					that.createModalForm();
					that.onFormReload();
				}
			});
		});
	}
}